import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Box, Skeleton, Typography, useTheme } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import InfiniteScroll from "react-infinite-scroll-component";
import useContentGlleryStyle from "./contentTypeCard/DamContentGllery.style";
import "./DamContentLeftSidebar.css";
import FolderMenu from "./FolderMenu";
import InlineListLoader from "./InlineListLoader";

type damCotentLeftSidebarProps = {
  toggleDrawer?: any;
  loading?: boolean;
  menuData: any;
  setUuid: Dispatch<SetStateAction<string | undefined>>;
  assetType: string;
  uuid: string;
  searchQuery: string;
  setCategoryLoading?: any;
  folder?: any;
  setFolder?: any;
  prevFolderState?: any;
  setPrevFolderState?: any;
  totalImageItem?: any;
  isImgLoad?: any;
  folderHasMore?: boolean;
  fetchMoreFolders?: () => void;
};

const DamContentLeftSidebar = (_props: damCotentLeftSidebarProps) => {
  const {
    toggleDrawer = () => {},
    loading,
    menuData,
    setUuid,
    assetType,
    uuid,
    searchQuery,
    setCategoryLoading,
    folder,
    setFolder,
    prevFolderState,
    setPrevFolderState,
    totalImageItem,
    isImgLoad,
    folderHasMore = false,
    fetchMoreFolders = () => {},
  } = _props;
  const theme = useTheme();
  const classes = useContentGlleryStyle();
  return (
    <Box
      className='damcontent-leftsidebar'
      sx={{
        padding: { xs: "0 0 0 16px", em: "0 0 0 20px" },
      }}>
      <Box
        sx={{
          padding: { em: "10px 15px 10px 0px", xs: "16px" },
          display: { sm: "flex", em: "none" },
          justifyContent: "space-between",
          borderBottom: { xs: `solid 1px ${theme?.palette.customColor?.LINE}`, em: "none" },
        }}>
        <Typography
          variant='h5semibold'
          sx={{
            textTransform: "uppercase",
          }}>
          <ArrowBackIosIcon
            className='back-to-page'
            onClick={() => toggleDrawer()}
            sx={{ display: { sm: "block", em: "none", fontSize: theme?.fontSize?.fontSize_18 } }}
          />
        </Typography>
      </Box>
      {loading ? (
        <Box
          className='leftsidebar-loader'
          sx={{
            padding: { em: "16px 16px 16px 0px" },
            height: "100%",
          }}>
          {Array.from(Array(4)).map((_element, i) => (
            <Box key={i}>
              {/* <Box key={i} className='skeleton skeleton-cat'></Box> */}
              <Skeleton
                variant='text'
                sx={{
                  fontSize: "1rem",
                  marginBottom: "5px",
                  width: "100%",
                  animation: "skeleton-loading 1s infinite alternate",
                }}
              />
            </Box>
          ))}
        </Box>
      ) : (
        <Box id='folderScrollableDiv' className={classes.leftsidebarbox}>
          <InfiniteScroll
            dataLength={menuData?.collectionItem?.length || 0}
            next={fetchMoreFolders}
            hasMore={folderHasMore}
            loader={<InlineListLoader />}
            scrollableTarget='folderScrollableDiv'>
            <FolderMenu
              communities={menuData.collectionItem}
              setUuid={setUuid}
              assetType={assetType}
              uuid={uuid}
              searchQuery={searchQuery}
              setCategoryLoading={setCategoryLoading}
              folder={folder}
              setFolder={setFolder}
              prevFolderState={prevFolderState}
              setPrevFolderState={setPrevFolderState}
              totalImageItem={totalImageItem}
              isImgLoad={isImgLoad}
            />
          </InfiniteScroll>
        </Box>
      )}
    </Box>
  );
};

export default DamContentLeftSidebar;
